module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductAvailability":{"availability":"Není skladem | Skladem {count} ks | Skladem {count} ks | Skladem > {count} ks","availableIn":"Nebude | (Doskladnění za {count} den) | (Doskladnění za {count} dny) | (Doskladnění za {count} dní)"}},"en":{"ProductAvailability":{"availability":"not in stock | {count} piece in stock | {count} pcs in stock | in stock > {count} pcs"}}}')
  delete Component.options._Ctor
}
